import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useColorModeValue } from "@chakra-ui/react";
import { allUsersSelector } from "store/user/selector";
import { unreadMessageSelector } from "store/project/selector";
import { transformProjectData, getColumnWidths } from "../helpers/dataTransform";
import { ProjectRowData, TransformedProjectData } from "../types";

export function useProjectsTable(
  tableData: ProjectRowData[],
  onShowProjectDetails: (projectId: string) => void
) {
  const allUsers = useSelector(allUsersSelector);
  const unreadMessages = useSelector(unreadMessageSelector);
  const textColor = useColorModeValue("black", "black");
  
  const transformedData = useMemo(() => {
    return transformProjectData(tableData, allUsers);
  }, [tableData, allUsers]);

  const [data, setData] = useState<TransformedProjectData[]>([]);

  useEffect(() => {
    setData(transformedData);
  }, [transformedData]);

  useEffect(() => {
    const hash = window.location.hash ?? null;
    if (hash) {
      const projectId = hash.replace("#", "");
      onShowProjectDetails(projectId);
    }
  }, [onShowProjectDetails]);

  const columnWidths = useMemo(() => getColumnWidths(), []);

  return {
    data,
    textColor,
    unreadMessages,
    columnWidths,
  };
}
